import { useMutation } from '@tanstack/react-query';

import {
  useInvalidateChannelById,
  useInvalidateChannelsList,
} from '@/entities/channel';
import {
  IAuthorizeTgBotChannelRequest,
  IChannelDetailsDto,
  updateTgBotChannel,
} from '@/shared/api/channels';
import { useNotifications } from '@/shared/ui/Notifications';

interface IAuthorisationTgBotData {
  channelId: string;
  data: IAuthorizeTgBotChannelRequest;
}

export function useAuthorisationTgBot() {
  const invalidateChannelsList = useInvalidateChannelsList();
  const invalidateChannelsById = useInvalidateChannelById();
  const { addNotification } = useNotifications();

  const createMutation = useMutation({
    mutationFn: ({ channelId, data }: IAuthorisationTgBotData) =>
      updateTgBotChannel(channelId, data),
    onError: (error) => {
      addNotification({
        title: error.message,
        caption: error?.data?.details,
      });
    },
  });

  const authorizeTgBot = (
    channelId: string,
    data: IAuthorizeTgBotChannelRequest,
    onCreated?: (data: IChannelDetailsDto) => void
  ) => {
    return createMutation.mutateAsync(
      { channelId, data },
      {
        onSuccess: async (channel) => {
          onCreated?.(channel);
          await Promise.all([
            invalidateChannelsList(),
            invalidateChannelsById(channel.id),
          ]);
        },
      }
    );
  };

  return { authorizeTgBot, ...createMutation };
}
